// extracted by mini-css-extract-plugin
export default {"buttons":"MilestoneForm_buttons__BsVrR"};